import { StyledDraggableContent } from './DraggableContent.styled';
import { useMemo } from 'react';

export default function DraggableContent({
  id,
  className,
  style,
  children,
  rotLimits,
  yLimits,
  rndYSign,
  rndRotSign,
  integerYRnd,
  integerRotRnd,
}) {
  rotLimits = rotLimits ?? { min: 1, max: 6 };
  yLimits = yLimits ?? { min: 2, max: 15 };
  rndYSign = rndYSign ?? true;
  rndRotSign = rndRotSign ?? true;
  integerYRnd = integerYRnd ?? false;
  integerRotRnd = integerRotRnd ?? false;
  const { rot, y } = useMemo(() => {
    return {
      rot: rndValue({
        ...rotLimits,
        rndSign: rndRotSign,
        integer: integerRotRnd,
      }),
      y: rndValue({ ...yLimits, rndSign: rndYSign, integer: integerYRnd }),
    };
  }, [id]);
  return (
    <StyledDraggableContent
      className={`option ${className ? className : ''}`}
      style={style}
      rot={rot}
      y={y}
    >
      {children}
    </StyledDraggableContent>
  );
}

function rndValue({ min, max, rndSign = true, integer = false }) {
  let rnd = Math.random() * (max - min + 1) + min;
  if (rndSign) {
    rnd = Math.random() > 0.5 ? rnd : -rnd;
  }
  return integer ? Math.round(rnd) : rnd;
}
